/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconKeyboardArrowRightFilled from 'DesignSystem/Svgs/TysiaIconKeyboardArrowRightFilled/index'



/** @type {import('Simple/types.js').View} */
export default function NextAction({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarNav/NextAction",
  onClick
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 marginRight={dtSpaceXxs}
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconKeyboardArrowRightFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconKeyboardArrowRightFilled`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}